import axios from 'axios';
import store from '@/store/'


// Account 相關的 api
const accountRequest = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN+'/booking'
});

//預約日期相關API
export const apiBookingList = (data) => accountRequest.get('/',{
    params : data,
});

//預約價錢相關API
export const apiBookingTotalList = (data) => accountRequest.get('/total',{
    params : data,
});

//預約價錢相關API
export const apiBookingSend = (data) => accountRequest.post('/',data,{
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//我的預約
export const apiBookingMyList = (data) => accountRequest.get('/my',{
    params : data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//批次可用性查詢API
export const apiBookingBatchAvailability = (data) => accountRequest.get('/batch-availability',{
    params : data,
});

//批次預約提交API
export const apiBookingBatchSend = (data) => accountRequest.post('/batch', data, {
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//更新未付款預約時間API
export const apiBookingUpdateUnpaid = (data) => accountRequest.put('/unpaid-update', data, {
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});